<template>
  <div>
    <b-carousel
      id="carousel-fade"
     
      fade
      indicators
      v-model="slide"
      class="carousel-inner"
    >
      <b-carousel-slide
        v-for="(item) in data" :key="item.id"
        img-blank
      >
        <div v-if="item.attributes">
          <b-jumbotron header-level="5" bg-variant="medium" text-variant="dark" border-variant="dark">
              <template #header>{{item.attributes['event-name']}}</template>
              <template #lead>
                {{item.attributes['location']}}
              </template>
              <p>
                <!-- Beginning {{ams_data.attributes['start-at']}} -->
                Starts {{display_time(item.attributes['start-at'])}}
              </p>

              <hr text-variant="white" class="my-4">
              <p v-if="item.attributes['is-happening']" style="color: green;">
                Happening Now!!!
              </p>
              <template>
                <b-card md="1" bg-variant="none" body-bg-variant="medium"> {{description}}</b-card>
              </template>
              <p v-if="item.attributes['end-at']">
                <!-- Ends At {{ams_data.attributes['end-at']}} -->
                Ends {{display_time(item.attributes['end-at'])}}
              </p>
          </b-jumbotron>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, amsApiResourcePath, SHOWINGS} from '@/ams_route'
import {localeStringOfUTC} from '@/utils'

export default {
  data () {
    return {
      ams_type: SHOWINGS,
      // api_route: 'api/admin/v1/showings',
      included: [],
      data: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      slide: 0,
    }
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    per_page_setting: {
      Type: Number
    },
    api_path: {
      Type: String
    }
  },
  computed: {
    description() {
      return ("Description")
    },

  },
  methods: {
    apiPath () {
       return this.api_path ? this.api_path : ADMIN_PATH
    },
    apiResourcePath() {
      return amsApiResourcePath(this.apiPath(), this.ams_type)
    },
    doRefresh() {
      this.emit('refreshed', true)
    },
    callApi () {
      // window.console.log("filtering: " + this.apiResourcePath() + JSON.stringify(this.filtering, null, 4) )
      http_v1.get(this.apiResourcePath(), {
        params: {
            page: this.currentPage,
            per_page: this.per_page_setting,
            ... this.filtering
        }
      }).then(response => {
        if(response.status == 200) {
          this.totalRows = response.headers.total
          this.perPage = response.headers['per-page']
          this.data = response.data.data
          this.included = response.data.included
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.items = []
        this.totalRows = 0
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    display_time(timestamp) {
      return localeStringOfUTC(timestamp)
    }
  },
  mounted() {
    this.callApi()
  },
  watch: {
    refresh(val) {
      if(val === true) {
        this.currentPage = 1
        this.callApi()
        this.$emit('refreshed', val)
      }
    },
    currentPage() {
      this.callApi()
    }
  }
}
</script>
<style scoped>
hr { background-color: white; height: 2px; border: none; }
 .card {
     border: 3px solid white;
 }
</style>